export default __webpack_public_path__ + "images/RVOT_dark.4ceb61530b77be9cf0c6bdbc2500fe29.png";